module.exports = __webpack_public_path__ + "img/宝色股份LOGO.80e073a0.png";